import { getAllowedTenantIdsFromToken } from "./jwtPayload";

/**
 * Default accommodation / domain tenant key in ResiBot (MySQL, RAG, widget config).
 * Override with REACT_APP_RESIBOT_DEFAULT_TENANT — do not derive from user email; see architecture plan.
 */
export function getDefaultResibotTenantId() {
  const v = process.env.REACT_APP_RESIBOT_DEFAULT_TENANT;
  if (v && String(v).trim()) return String(v).trim().toLowerCase();
  return null;
}

function sessionUserKey(auth) {
  const u = (auth?.user || auth?.username || "").trim();
  return u ? u.replace(/[^a-z0-9_-]/gi, "_") : "anon";
}

const STORAGE_PREFIX = "resibot_dashboard_tenant:";

/** Per logged-in user so two accounts on one browser do not share the picker value. */
export function storageKeyForSelectedTenant(auth) {
  return `${STORAGE_PREFIX}${sessionUserKey(auth)}`;
}

/**
 * Effective X-Tenant-ID: REACT_APP_RESIBOT_TENANT_ID > saved picker (if allowed by JWT) >
 * JWT tenant_id(s) > default accommodation tenant (not username/email slug).
 */
export function resolveEffectiveTenantId(auth, accessToken) {
  const fromEnv = process.env.REACT_APP_RESIBOT_TENANT_ID;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().toLowerCase();
  }
  const allowed = getAllowedTenantIdsFromToken(accessToken);
  try {
    const raw = sessionStorage.getItem(storageKeyForSelectedTenant(auth));
    if (raw && allowed.includes(raw)) return raw;
  } catch {
    /* private mode */
  }
  if (allowed.length > 0) return allowed[0];
  return getDefaultResibotTenantId();
}
